const EliminarToken = (abrir) => {
    localStorage.clear();
    setTimeout(() => {
        abrir();
    }, 2500);
}

export default EliminarToken;